<template>
  <div>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :loading="disable"
      :columns="columns"
      v-model:pagination="pagination"
      class="q-mt-md my-sticky-dynamic"
      row-key="name"
      dense
      ref="table"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          v-model="filtrar"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th
            class="text-weight-bolder"
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
          >
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template #body-cell-users_name="props">
        <q-td>
          {{ props.row.users_name }}
        </q-td>
      </template>
      <template #body-cell-cost_center_epi_name="props">
        <q-td>
          {{ props.row.cost_center_epi_name }}
        </q-td>
      </template>
      <template #body-cell-refresh="props">
        <q-td>
          <q-btn
            v-if="props"
            round
            color="positive"
            icon="refresh"
            flat
            @click="
              confirmarReativacao(props.row.users_id),
                (reativarDialog = !reativarDialog)
            "
          />
        </q-td>
      </template>
      <template #body-cell-users_created_at="props">
        <q-td>
          <div class="row">
            <span>{{
              props.row.users_created_at
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
            <span class="q-ml-sm">{{
              props.row.users_created_at.split(" ")[1]
            }}</span>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <dialog-info-design
      v-model="dialogConfirmacao"
      mensagem="Confirma reativação?"
      subMensagem="Tem certeza que deseja reativar o colaborador?"
      :exibir="reativarDialog"
      :showCancelar="true"
      @resultado="reativarConfirmado"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "users_id",
    label: "ID",
    field: "users_id",
    align: "left",
  },
  {
    name: "users_name",
    label: "Nome",
    field: "users_name",
    align: "left",
  },
  {
    name: "users_sap",
    label: "Sap",
    field: "users_sap",
    align: "left",
  },
  {
    name: "roles_name",
    label: "Perfil",
    field: "roles_name",
    align: "left",
  },
  {
    name: "cost_center_epi_name",
    label: "CC EPI",
    field: "cost_center_epi_name",
    align: "left",
  },
  {
    name: "cost_centers_name",
    label: "CC MATERIAL",
    field: "cost_centers_name",
    align: "left",
  },
  {
    name: "vendors_name",
    label: "Unidade",
    field: "vendors_name",
    align: "left",
  },
  {
    name: "aprovador_centro_custo",
    label: "Aprovador",
    field: (row) => (row.aprovador_centro_custo == 0 ? "Não" : "Sim"),
    align: "left",
  },
  {
    name: "users_created_at",
    label: "Criado em",
    field: "users_created_at",
    align: "left",
  },

  {
    name: "refresh",
    label: "Reativar",
    field: "refresh",
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
export default {
  components: { DialogInfoDesign },
  props: ["atualizar"],
  emits: ["update:total"],
  setup(props, { emit }) {
    const disable = ref(true);
    const rows = ref([]);
    const store = useStore();
    const quasar = useQuasar();
    const unidade = ref("");
    const filtrar = ref("");
    const router = useRouter();
    const route = useRoute();
    const table = ref("");
    const dialogConfirmacao = ref(false);
    const usuarioSelecionado = ref(null);
    const reativarDialog = ref(false);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getData = async (page = 0, rowsPerPage = 15) => {
      disable.value = true;
      quasar.loading.show();
      try {
        let response = await store.dispatch("user/getUsuariosDesligados", {
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
          vendor_id: unidade.value.id,
        });

        rows.value = response.data.data;

        pagination.value.page = response.data.current_page;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        emit("update:total", response.data.total);
        disable.value = false;
        scrollUp();
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reativar = async (id) => {
      try {
        await store.dispatch("user/reativarUsuarioDesligado", {
          user_id: id,
        });
        quasar.notify({
          message: "Usuario reativado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getData();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o reativar usuario",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
      getData();
    };

    const confirmarReativacao = (user_id) => {
      usuarioSelecionado.value = user_id;
      dialogConfirmacao.value = true;
    };

    const reativarConfirmado = async (resultado) => {
      reativarDialog.value = false;
      if (!resultado) return;
      try {
        await store.dispatch("user/reativarUsuarioDesligado", {
          user_id: usuarioSelecionado.value,
        });
        quasar.notify({
          message: "Usuário reativado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });
        getData();
      } catch (error) {
        quasar.notify({
          message: "Erro ao reativar usuário",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        dialogConfirmacao.value = false;
        usuarioSelecionado.value = null;
      }
    };

    const scrollUp = () => {
      table.value.scrollTo(0);
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
      getData();
    };

    onMounted(getUnidade);

    watch(
      () => props.atualizar,
      () => {
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        router.push({
          path: route.path,
          query: { page: pagination.value.page },
        });
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.id = store.state.org.unidadeData.id;
        getData();
      }
    );

    const handleRequest = async () => {
      getData(pagination.value.page, pagination.value.rowsPerPage);
    };
    return {
      disable,
      pagination,
      getData,
      rows,
      handleRequest,
      columns,
      filtrar,
      reativar,
      confirmarReativacao,
      reativarConfirmado,
      scrollUp,
      table,
      dialogConfirmacao,
      reativarDialog,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 0;
}
.my-sticky-dynamic {
  max-height: 600px;
}
thead tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
